/// <amd-module name="Artifacts/Maven/services/MavenRestApiUrlGeneratorService" />
import { generatePackagingServiceRestApiUri, IRestApiRoutes } from "Artifacts/Root/Utils/RestApi";
import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { replaceRouteValues } from "VSS/Platform/Util/Url";

const MavenArea = "maven";

// Content Download
const PackageVersionContent: IRestApiRoutes = {
  locationId: "C338D4B5-D30A-47E2-95B7-F157EF558833",
  resource: "content",
  routeTemplate:
    "packaging/feeds/{feedId}/{area}/{groupId}/{artifactId}/{packageVersion}/{fileName}/{resource}",
};

// Used in Ctf
const ServiceIndex: IRestApiRoutes = {
  locationId: "F285A171-0DF5-4C49-AAF2-17D0D37D9F0E",
  resource: "v1",
  // packaging is not mentioned in /Packaging/Service/Maven/Plugins/RestApiResourceProvider.cs
  // but present when _apis/npm endpoint is hit
  routeTemplate: "_packaging/{feed}/{area}/{resource}/{*path}",
};

export interface IMavenRestApiUrlGeneratorService extends IVssService {
  getEndpointUrl(feedId: string, showProjectInUrl: boolean, publicAccessMapping: string): string;
  getFileDownloadUrl(
    feedId: string,
    packageName: string,
    packageVersion: string,
    fileName: string,
    showProjectInUrl: boolean,
    publicAccessMapping: string,
  ): string;
}

class MavenRestApiUrlGeneratorService extends VssService
  implements IMavenRestApiUrlGeneratorService {
  public getEndpointUrl(
    feedId: string,
    showProjectInUrl: boolean,
    publicAccessMapping: string,
  ): string {
    const path = replaceRouteValues(ServiceIndex.routeTemplate, {
      feed: feedId,
      area: MavenArea,
      resource: ServiceIndex.resource,
    });
    return generatePackagingServiceRestApiUri(
      this.pageContext,
      path,
      publicAccessMapping,
      true /* ignoreApisRelativePath */,
      showProjectInUrl,
    );
  }

  public getFileDownloadUrl(
    feedId: string,
    packageName: string,
    packageVersion: string,
    fileName: string,
    showProjectInUrl: boolean,
    publicAccessMapping: string,
  ): string {
    const nameParts = packageName ? packageName.split(":") : null;
    const groupId = nameParts ? nameParts[0] : "";
    const artifactId = nameParts ? nameParts[1] : "";
    let path = "";
    path = replaceRouteValues(PackageVersionContent.routeTemplate, {
      feedId,
      area: MavenArea,
      groupId,
      artifactId,
      packageVersion,
      fileName,
      resource: PackageVersionContent.resource,
    });
    return generatePackagingServiceRestApiUri(
      this.pageContext,
      path,
      publicAccessMapping,
      false,
      showProjectInUrl,
    );
  }
}

Services.add("IMavenRestApiUrlGeneratorService", {
  serviceFactory: MavenRestApiUrlGeneratorService,
});
